import { Injectable } from '@angular/core';

@Injectable()
export class AppNavbarVerticalService {
    navBarRef;

    constructor() {
        //This method is empty on purpose
    }

    setNavBar(ref) {
        this.navBarRef = ref;
    }

    getNavBar() {
        return this.navBarRef;
    }
}
